<div class="desktop-container">
    <div class="mobile-container">  
        <router-outlet></router-outlet>
        <app-toast [showToast]="(showToast$ | async)"></app-toast>        
        <app-install-toast></app-install-toast>
    </div>
</div>

